type PropertyType = 'house' | 'condo' | 'townhouse' | 'land' | 'farm' | 'commercial';

/**
 * Creates a query string for property type filters.
 *
 * @param trueTypes - An array of property types to set to 'true'.
 * @returns A URL query string with specified types as true and all others as false.
 */
export const createHomeTypeQuery = (trueTypes: PropertyType[]): string => {
  const allTypes: PropertyType[] = ['house', 'condo', 'townhouse', 'land', 'farm', 'commercial'];
  const params = new URLSearchParams();
  allTypes.forEach(type => {
    params.append(type, trueTypes.includes(type) ? 'true' : 'false');
  });
  return params.toString();
};

/**
 * Creates a divider navigation item for use within dropdown menus
 * Since dividers are purely visual, they don't need meaningful IDs
 */
export const createDivider = () => ({
  id: 'divider',
  type: 'divider' as const,
}); 